import React, { Component } from 'react';
import { connect } from 'react-redux';
import Zoom from '@material-ui/core/Zoom';
import Fab from '@material-ui/core/Fab';
import { Check, BookmarkBorder } from '@material-ui/icons';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Box } from '@material-ui/core';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import TargetPopSearchAreaComponent from './TargetPopSearchAreaComponent';
import TargetPopSearchIndustryComponent from './TargetPopSearchIndustryComponent';
import TargetPopSearchProductsComponent from './TargetPopSearchProductsComponent';
import TargetPopSetTradeInfoComponent from './TargetPopSetTradeInfoComponent';
import SerchTargetParts from './TargetSerchComponentParts/SerchTargetParts';
import AdditionalInfometionParts from './TargetSerchComponentParts/AdditionalInfometionParts';
import CompanyBasicInfomation from './TargetSerchComponentParts/CompanyBasicInfomation';
import EvaluationIndexParts from './TargetSerchComponentParts/EvaluationIndexParts';
import SettlementInfomation from './TargetSerchComponentParts/SettlementInfomation';
import RelatedCompanyParts from './TargetSerchComponentParts/RelatedCompanyParts';
import JigyosyoInfomationParts from './TargetSerchComponentParts/JigyosyoInfomationParts';
import './TargetSearchComponent.css';
import {
  SHUBETSU_CODE,
  TARGET_SEARCH_DISP_ITEM,
} from '../../../common/const';
import {
  getAreaMaster,
  getAddressMaster,
  setSystemLodingFLg,
  getContractLabel,
  setContractLabel,
  getCodeMaster,
} from '../../actions/CommonAction';
import {
  setArea,
  setAddressCondition,
  setIndustryCondition,
  setIndustryAddCondition,
  setProductAddCondition,
  setProductsCondition,
  setMainIndustryFlg,
  setTradeInfoSearchItemList,
  setTargetListHeaderItem,
  setTradeInfoSearchItem,
  setAddressPopFlg,
  setIndustryPopFlg,
  setProductsPopFlg,
  setTradeInfoPopFlg,
  setSearchTarget,
  setAccountMonth,
  setCapitalFrom,
  setCapitalTo,
  setSalesFrom,
  setSalesTo,
  setSalesRateFrom,
  setSalesRateTo,
  setBenefitFrom,
  setBenefitTo,
  setBenefitRateFrom,
  setBenefitRateTo,
  setEmployeeFrom,
  setEmployeeTo,
  setTopDuns,
  setTopTsrCode,
  setScoreFrom,
  setScoreTo,
  setOfficeCountFrom,
  setOfficeCountTo,
  setRepLastName,
  setRepFirstName,
  setAdditionalitem,
  setTradesearchflag1,
  setTradesearchflag2,
  setPrefList,
  setSelectArea,
  setSelectPref,
  setDispCapitalFrom,
  setDispCapitalTo,
  setDispSalesFrom,
  setDispSalesTo,
  setDispSalesRateFrom,
  setDispSalesRateTo,
  setDispBenefitFrom,
  setDispBenefitTo,
  setDispBenefitRateFrom,
  setDispBenefitRateTo,
  setDispEmployeesFrom,
  setDispEmployeesTo,
  setDispOfficeCountFrom,
  setDispOfficeCountTo,
  setErrMsgCapital,
  setErrMsgSales,
  setErrMsgRate,
  setErrMsgBenefit,
  setErrMsgBenefitRate,
  setErrMsgEmployees,
  setErrMsgTopDuns,
  setErrMsgTopTsrCode,
  setErrMsgScore,
  setErrMsgOfficeCount,
  setErrMsgRepName,
  setErrMsgTradeInfoSearchValue,
  setCheckCapitalFrom,
  setCheckCapitalTo,
  setCheckSalesFrom,
  setCheckSalesTo,
  setCheckRateFrom,
  setCheckRateTo,
  setCheckBenefitFrom,
  setCheckBenefitTo,
  setCheckBenefitRateFrom,
  setCheckBenefitRateTo,
  setCheckEmployeesFrom,
  setCheckEmployeesTo,
  setCheckTopDuns,
  setCheckTopTsrCode,
  setCheckScoreFrom,
  setCheckScoreTo,
  setCheckOfficeCountFrom,
  setCheckOfficeCountTo,
  setCheckRepLastName,
  setCheckRepFirstName,
  setCheckTradeInfoSearchValue,
  getTradeInfoMaster,
  setSelectConditionFlg,
  setMarketSegmentList,
  setCheckSgkn,
  setErrMsgSgkn,
  setCheckStartYearFrom,
  setCheckStartMonthFrom,
  setCheckStartYearTo,
  setCheckStartMonthTo,
  setErrMsgStartYm,
  setCheckSyrkGkny,
  setErrMsgSyrkGkny,
  setDispJgkbList,
  setTargetingDispItems,
  getTargetingDispItemList,
  setScoreSlider,
  getDownloadStatus,
} from '../../actions/TargetAction';

const ScrollTop = (props) => {
  const { children } = props;
  const trigger = true;

  const handleClick = (event) => {
    const scrollToWindow = (event.target.ownerDocument || document).querySelector('.content');
    if (scrollToWindow) {
      scrollToWindow.scrollTo(0, 0);
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className="zoom">
        {children}
      </div>
    </Zoom>
  );
};

class TargetSearchComponent extends Component {
  componentDidMount = async () => {
    const {
      getContractLabelAct,
      setContractLabelAct,
      setAddressPopFlgAct,
      setIndustryPopFlgAct,
      setProductsPopFlgAct,
      setTradeInfoPopFlgAct,
      setSelectConditionFlgAct,
      getCodeMasterAct,
      setMarketSegmentListAct,
      marketSegmentList,
      setDispJgkbListAct,
      dispJgkbList,
      getTargetingDispItemListAct,
      setTargetingDispItemsAct,
      targetingDispItems,
    } = this.props;
    const contlactLabel = await getContractLabelAct();
    setContractLabelAct(contlactLabel);
    setAddressPopFlgAct(false);
    setIndustryPopFlgAct(false);
    setProductsPopFlgAct(false);
    setTradeInfoPopFlgAct(false);
    setSelectConditionFlgAct(false);

    // ターゲティング画面項目マスタ取得
    if (!targetingDispItems) {
      const ret = await getTargetingDispItemListAct();
      if (ret) {
        setTargetingDispItemsAct(ret);
      }
    }

    // 上場市場取得
    if (!marketSegmentList) {
      const ret = await getCodeMasterAct(SHUBETSU_CODE.CD0023);
      if (ret && ret.code_list) {
        setMarketSegmentListAct(ret.code_list);
      }
    }

    // 事業所区分取得
    if (!dispJgkbList || dispJgkbList.length === 0) {
      const ret = await getCodeMasterAct(SHUBETSU_CODE.CD0047);
      if (ret && ret.code_list) {
        setDispJgkbListAct(ret.code_list);
      }
    }
  }

  componentDidUpdate = async () => {
    const {
      selectConditionFlg,
      setSelectConditionFlgAct,
    } = this.props;

    if (selectConditionFlg) {
      // フォーカスアウト時のイベント
      this.onBlurCapital();
      this.onBlurSales();
      this.onBlurRate();
      this.onBlurBenefit();
      this.onBlurBenefitRate();
      this.onBlurEmployees();
      this.onBlurTopDuns();
      this.onBlurTopTsrCode();
      this.onBlurScore();
      this.onBlurRepName();
      this.onBlurOfficeCount();
      this.onBlurSgkn();
      this.onBlurSyrkGkny();
      this.onBlurStartYm();

      setSelectConditionFlgAct(false);
    }
  }

  /**
   * 資本金FROM文字種、最大桁数のチェック
   * 資本金TO文字種、最大桁数のチェック
   */
  onBlurCapital = () => {
    const {
      dispCapitalFrom,
      dispCapitalTo,
      setCapitalFromAct,
      setCapitalToAct,
      setCheckCapitalFromAct,
      setCheckCapitalToAct,
      setErrMsgCapitalAct,
      setDispCapitalFromAct,
      setDispCapitalToAct,
    } = this.props;

    // カンマ除去
    const capitalFrom = dispCapitalFrom && dispCapitalFrom.replace(/,/g, '');
    const capitalTo = dispCapitalTo && dispCapitalTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setCapitalFromAct(capitalFrom);
    setCapitalToAct(capitalTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(capitalFrom, VALIDATOR_CONST.PATERN_POSITIVE, msgs1);
    validator.checkChar(capitalTo, VALIDATOR_CONST.PATERN_POSITIVE, msgs2);
    validator.checkMaxLength(capitalFrom, 11, msgs1);
    validator.checkMaxLength(capitalTo, 11, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgCapitalAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckCapitalFromAct(errFlg1);
      setCheckCapitalToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgCapitalAct();
    setCheckCapitalFromAct(false);
    setCheckCapitalToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispCapitalFromAct(capitalFrom ? Number(capitalFrom).toLocaleString() : '');
    setDispCapitalToAct(capitalTo ? Number(capitalTo).toLocaleString() : '');
  }

  /**
   * 売上高FROM文字種、最大桁数のチェック
   * 売上高TO文字種、最大桁数のチェック
   */
  onBlurSales = () => {
    const {
      dispSalesFrom,
      dispSalesTo,
      setSalesFromAct,
      setSalesToAct,
      setCheckSalesFromAct,
      setCheckSalesToAct,
      setErrMsgSalesAct,
      setDispSalesFromAct,
      setDispSalesToAct,
    } = this.props;

    // カンマ除去
    const salesFrom = dispSalesFrom && dispSalesFrom.replace(/,/g, '');
    const salesTo = dispSalesTo && dispSalesTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setSalesFromAct(salesFrom);
    setSalesToAct(salesTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(salesFrom, VALIDATOR_CONST.PATERN_SIGNED, msgs1);
    validator.checkChar(salesTo, VALIDATOR_CONST.PATERN_SIGNED, msgs2);
    validator.checkMaxLength(salesFrom, 16, msgs1);
    validator.checkMaxLength(salesTo, 16, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgSalesAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckSalesFromAct(errFlg1);
      setCheckSalesToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgSalesAct();
    setCheckSalesFromAct(false);
    setCheckSalesToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispSalesFromAct(salesFrom ? salesFrom.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '');
    setDispSalesToAct(salesTo ? salesTo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '');
  }

  /**
   * 売上高伸び率FROM文字種、最大桁数のチェック
   * 売上高伸び率TO文字種、最大桁数のチェック
   */
  onBlurRate = () => {
    const {
      dispSalesRateFrom,
      dispSalesRateTo,
      setSalesRateFromAct,
      setSalesRateToAct,
      setCheckRateFromAct,
      setCheckRateToAct,
      setErrMsgRateAct,
      setDispSalesRateFromAct,
      setDispSalesRateToAct,
    } = this.props;

    // カンマ除去
    const salesRateFrom = dispSalesRateFrom && dispSalesRateFrom.replace(/,/g, '');
    const salesRateTo = dispSalesRateTo && dispSalesRateTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setSalesRateFromAct(salesRateFrom);
    setSalesRateToAct(salesRateTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(salesRateFrom, VALIDATOR_CONST.PATERN_DECIMAL, msgs1);
    validator.checkChar(salesRateTo, VALIDATOR_CONST.PATERN_DECIMAL, msgs2);
    validator.checkMaxLength(salesRateFrom, 11, msgs1);
    validator.checkMaxLength(salesRateTo, 11, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgRateAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckRateFromAct(errFlg1);
      setCheckRateToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgRateAct();
    setCheckRateFromAct(false);
    setCheckRateToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispSalesRateFromAct(salesRateFrom ? Number(salesRateFrom).toLocaleString() : '');
    setDispSalesRateToAct(salesRateTo ? Number(salesRateTo).toLocaleString() : '');
  }

  /**
   * 利益金FROM文字種、最大桁数のチェック
   * 利益金TO文字種、最大桁数のチェック
   */
  onBlurBenefit = () => {
    const {
      dispBenefitFrom,
      dispBenefitTo,
      setBenefitFromAct,
      setBenefitToAct,
      setCheckBenefitFromAct,
      setCheckBenefitToAct,
      setErrMsgBenefitAct,
      setDispBenefitFromAct,
      setDispBenefitToAct,
    } = this.props;

    // カンマ除去
    const benefitFrom = dispBenefitFrom && dispBenefitFrom.replace(/,/g, '');
    const benefitTo = dispBenefitTo && dispBenefitTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setBenefitFromAct(benefitFrom);
    setBenefitToAct(benefitTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(benefitFrom, VALIDATOR_CONST.PATERN_SIGNED, msgs1);
    validator.checkChar(benefitTo, VALIDATOR_CONST.PATERN_SIGNED, msgs2);
    validator.checkMaxLength(benefitFrom, 13, msgs1);
    validator.checkMaxLength(benefitTo, 13, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgBenefitAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckBenefitFromAct(errFlg1);
      setCheckBenefitToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgBenefitAct();
    setCheckBenefitFromAct(false);
    setCheckBenefitToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispBenefitFromAct(benefitFrom ? Number(benefitFrom).toLocaleString() : '');
    setDispBenefitToAct(benefitTo ? Number(benefitTo).toLocaleString() : '');
  }

  /**
   * 利益伸び率FROM文字種、最大桁数のチェック
   * 利益伸び率TO文字種、最大桁数のチェック
   */
  onBlurBenefitRate = () => {
    const {
      dispBenefitRateFrom,
      dispBenefitRateTo,
      setBenefitRateFromAct,
      setBenefitRateToAct,
      setCheckBenefitRateFromAct,
      setCheckBenefitRateToAct,
      setErrMsgBenefitRateAct,
      setDispBenefitRateFromAct,
      setDispBenefitRateToAct,
    } = this.props;

    // カンマ除去
    const benefitRateFrom = dispBenefitRateFrom && dispBenefitRateFrom.replace(/,/g, '');
    const benefitRateTo = dispBenefitRateTo && dispBenefitRateTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setBenefitRateFromAct(benefitRateFrom);
    setBenefitRateToAct(benefitRateTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(benefitRateFrom, VALIDATOR_CONST.PATERN_DECIMAL, msgs1);
    validator.checkChar(benefitRateTo, VALIDATOR_CONST.PATERN_DECIMAL, msgs2);
    validator.checkMaxLength(benefitRateFrom, 11, msgs1);
    validator.checkMaxLength(benefitRateTo, 11, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgBenefitRateAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckBenefitRateFromAct(errFlg1);
      setCheckBenefitRateToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgBenefitRateAct();
    setCheckBenefitRateFromAct(false);
    setCheckBenefitRateToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispBenefitRateFromAct(benefitRateFrom ? Number(benefitRateFrom).toLocaleString() : '');
    setDispBenefitRateToAct(benefitRateTo ? Number(benefitRateTo).toLocaleString() : '');
  }

  /**
   * 従業員数FROM文字種、最大桁数のチェック
   * 従業員数TO文字種、最大桁数のチェック
   */
  onBlurEmployees = () => {
    const {
      dispEmployeesFrom,
      dispEmployeesTo,
      setEmployeeFromAct,
      setEmployeeToAct,
      setCheckEmployeesFromAct,
      setCheckEmployeesToAct,
      setErrMsgEmployeesAct,
      setDispEmployeesFromAct,
      setDispEmployeesToAct,
    } = this.props;

    // カンマ除去
    const employeeFrom = dispEmployeesFrom && dispEmployeesFrom.replace(/,/g, '');
    const employeeTo = dispEmployeesTo && dispEmployeesTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setEmployeeFromAct(employeeFrom);
    setEmployeeToAct(employeeTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(employeeFrom, VALIDATOR_CONST.PATERN_POSITIVE, msgs1);
    validator.checkChar(employeeTo, VALIDATOR_CONST.PATERN_POSITIVE, msgs2);
    validator.checkMaxLength(employeeFrom, 7, msgs1);
    validator.checkMaxLength(employeeTo, 7, msgs2);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgEmployeesAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckEmployeesFromAct(errFlg1);
      setCheckEmployeesToAct(errFlg2);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgEmployeesAct();
    setCheckEmployeesFromAct(false);
    setCheckEmployeesToAct(false);
    // 表示内容を更新(3桁カンマを付与)
    setDispEmployeesFromAct(employeeFrom ? Number(employeeFrom).toLocaleString() : '');
    setDispEmployeesToAct(employeeTo ? Number(employeeTo).toLocaleString() : '');
  }

  /**
   * 国内最上位親会社DUNS文字種、桁数のチェック
   */
  onBlurTopDuns = () => {
    const {
      topDuns,
      setCheckTopDunsAct,
      setErrMsgTopDunsAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkChar(topDuns, VALIDATOR_CONST.PATERN_NUM, msgs);
    validator.checkLength(topDuns, 9, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgTopDunsAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckTopDunsAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgTopDunsAct();
    setCheckTopDunsAct(false);
  }

  /**
   * 国内最上位親会社TSRコード文字種、桁数のチェック
   */
  onBlurTopTsrCode = () => {
    const {
      topTsrCode,
      setCheckTopTsrCodeAct,
      setErrMsgTopTsrCodeAct,
    } = this.props;

    // 入力チェック
    const msgs = [];
    validator.checkChar(topTsrCode, VALIDATOR_CONST.PATERN_NUM, msgs);
    validator.checkLength(topTsrCode, 9, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgTopTsrCodeAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckTopTsrCodeAct(true);
      return;
    }

    // エラー無しの場合
    // エラーメッセージ、エラーフラグを解除
    setErrMsgTopTsrCodeAct();
    setCheckTopTsrCodeAct(false);
  }

  /**
   * 代表者苗字文字種、最大桁数のチェック
   * 代表者名前文字種、最大桁数のチェック
   */
  onBlurRepName = () => {
    const {
      repLastName,
      repFirstName,
      setCheckRepLastNameAct,
      setCheckRepFirstNameAct,
      setErrMsgRepNameAct,
    } = this.props;

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    const repFullName = repLastName + repFirstName;
    validator.checkChar(repLastName, VALIDATOR_CONST.PATERN_FULL_WIDTH, msgs1);
    validator.checkChar(repFirstName, VALIDATOR_CONST.PATERN_FULL_WIDTH, msgs2);
    validator.checkMaxLength(repLastName, 100, msgs1);
    validator.checkMaxLength(repFirstName, 100, msgs2);
    // 苗字と名前が両方入力されている場合、フルネームでチェックする
    if (repLastName && repFirstName) {
      validator.checkMaxLength(repFullName, 100, msgs1);
      validator.checkMaxLength(repFullName, 100, msgs2);
    }

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgRepNameAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckRepLastNameAct(errFlg1);
      setCheckRepFirstNameAct(errFlg2);
      return;
    }
    setErrMsgRepNameAct();
    setCheckRepLastNameAct(false);
    setCheckRepFirstNameAct(false);
  }

  /**
   * 事業所数FROM文字種、最大桁数のチェック
   * 事業所数TO文字種、最大桁数のチェック
   */
  onBlurOfficeCount = () => {
    const {
      dispOfficeCountFrom,
      dispOfficeCountTo,
      setOfficeCountFromAct,
      setOfficeCountToAct,
      setCheckOfficeCountFromAct,
      setCheckOfficeCountToAct,
      setErrMsgOfficeCountAct,
      setDispOfficeCountFromAct,
      setDispOfficeCountToAct,
    } = this.props;

    // カンマ除去
    const officeCountFrom = dispOfficeCountFrom && dispOfficeCountFrom.replace(/,/g, '');
    const officeCountTo = dispOfficeCountTo && dispOfficeCountTo.replace(/,/g, '');

    // リクエストパラメータ用項目設定
    setOfficeCountFromAct(officeCountFrom);
    setOfficeCountToAct(officeCountTo);

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(officeCountFrom, VALIDATOR_CONST.PATERN_POSITIVE, msgs1);
    validator.checkChar(officeCountTo, VALIDATOR_CONST.PATERN_POSITIVE, msgs2);
    validator.checkNumberRange(officeCountFrom, 1, 99999, msgs1);
    validator.checkNumberRange(officeCountTo, 1, 99999, msgs2);
    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgOfficeCountAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckOfficeCountFromAct(errFlg1);
      setCheckOfficeCountToAct(errFlg2);
      return;
    }
    setErrMsgOfficeCountAct();
    setCheckOfficeCountFromAct(false);
    setCheckOfficeCountToAct(false);

    // 表示内容を更新(3桁カンマを付与)
    setDispOfficeCountFromAct(officeCountFrom ? Number(officeCountFrom).toLocaleString() : '');
    setDispOfficeCountToAct(officeCountTo ? Number(officeCountTo).toLocaleString() : '');
  }

  /**
   * 商号漢字文字種、最大桁数のチェック
   */
  onBlurSgkn = () => {
    const {
      sgkn,
      setCheckSgknAct,
      setErrMsgSgknAct,
    } = this.props;

    // 入力チェック
    const msgs = [];

    validator.checkChar(sgkn, VALIDATOR_CONST.PATERN_FULL_WIDTH, msgs);
    validator.checkMaxLength(sgkn, 60, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgSgknAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckSgknAct(true);
      return;
    }
    setErrMsgSgknAct();
    setCheckSgknAct(false);
  }

  /**
   * 設立年月FROM文字種、最大桁数のチェック
   * 設立年月TO文字種、最大桁数のチェック
   */
  onBlurStartYm = () => {
    const {
      startYearFrom,
      startMonthFrom,
      startYearTo,
      startMonthTo,
      setCheckStartYearFromAct,
      setCheckStartMonthFromAct,
      setCheckStartYearToAct,
      setCheckStartMonthToAct,
      setErrMsgStartYmAct,
    } = this.props;

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    const msgs3 = [];
    const msgs4 = [];

    validator.checkChar(startYearFrom, VALIDATOR_CONST.PATERN_YEAR, msgs1);
    validator.checkChar(startMonthFrom, VALIDATOR_CONST.PATERN_MONTH, msgs2);
    validator.checkChar(startYearTo, VALIDATOR_CONST.PATERN_YEAR, msgs3);
    validator.checkChar(startMonthTo, VALIDATOR_CONST.PATERN_MONTH, msgs4);

    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;
    const errFlg3 = msgs3.length !== 0;
    const errFlg4 = msgs4.length !== 0;

    if (errFlg1 || errFlg2 || errFlg3 || errFlg4) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2).concat(msgs3).concat(msgs4))];
      setErrMsgStartYmAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckStartYearFromAct(errFlg1);
      setCheckStartMonthFromAct(errFlg2);
      setCheckStartYearToAct(errFlg3);
      setCheckStartMonthToAct(errFlg4);
      return;
    }

    // 必須チェック
    const msgs5 = [];
    const msgs6 = [];
    if (startMonthFrom) {
      validator.checkRequired('年', startYearFrom, msgs5);
    }

    if (startMonthTo) {
      validator.checkRequired('年', startYearTo, msgs6);
    }

    const errFlg5 = msgs5.length !== 0;
    const errFlg6 = msgs6.length !== 0;

    if (errFlg5 || errFlg6) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = msgs5.length !== 0 ? msgs5 : msgs6;
      setErrMsgStartYmAct(msgs);
      setCheckStartYearFromAct(errFlg5);
      setCheckStartYearToAct(errFlg6);
      return;
    }

    setErrMsgStartYmAct();
    setCheckStartYearFromAct(false);
    setCheckStartMonthFromAct(false);
    setCheckStartYearToAct(false);
    setCheckStartMonthToAct(false);
  }

  /**
   * 概況文字種、最大桁数のチェック
   */
  onBlurSyrkGkny = () => {
    const {
      syrkGkny,
      setCheckSyrkGknyAct,
      setErrMsgSyrkGknyAct,
    } = this.props;

    // 入力チェック
    const msgs = [];

    validator.checkChar(syrkGkny, VALIDATOR_CONST.PATERN_FULL_WIDTH, msgs);
    validator.checkMaxLength(syrkGkny, 60, msgs);

    if (msgs.length !== 0) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      setErrMsgSyrkGknyAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckSyrkGknyAct(true);
      return;
    }
    setErrMsgSyrkGknyAct();
    setCheckSyrkGknyAct(false);
  }

  /**
   * セレクトボックスから選択中のデータを取得
   */
  getSelectedList = (target) => {
    const selectedList = [];
    for (let i = 0; i < target.length; i += 1) {
      const option = target.options[i];
      if (option.selected) {
        const item = {
          code: option.value,
          name: option.text,
          data: option.dataset,
        };
        selectedList.push(item);
      }
    }
    return selectedList;
  }

  /**
   * 評点FROM文字種、最大桁数のチェック
   * 評点TO文字種、最大桁数のチェック
   */
  onBlurScore = () => {
    const {
      scoreFrom,
      scoreTo,
      setCheckScoreFromAct,
      setCheckScoreToAct,
      setErrMsgScoreAct,
      setScoreSliderAct,
      setScoreFromAct,
      setScoreToAct,
    } = this.props;

    // 入力チェック
    const msgs1 = [];
    const msgs2 = [];
    validator.checkChar(scoreFrom, VALIDATOR_CONST.PATERN_POSITIVE, msgs1);
    validator.checkChar(scoreTo, VALIDATOR_CONST.PATERN_POSITIVE, msgs2);
    validator.checkNumberRange(scoreFrom, 0, 100, msgs1);
    validator.checkNumberRange(scoreTo, 0, 100, msgs2);
    const errFlg1 = msgs1.length !== 0;
    const errFlg2 = msgs2.length !== 0;

    if (errFlg1 || errFlg2) {
      // エラー有りの場合
      // エラーメッセージ、エラーフラグを設定
      const msgs = [...new Set(msgs1.concat(msgs2))];
      setErrMsgScoreAct(getMessage(ERROR.E08009, msgs.join(',')));
      setCheckScoreFromAct(errFlg1);
      setCheckScoreToAct(errFlg2);
      return;
    }

    // 評点バー設定
    const ScoreSlider = [];
    if (scoreFrom !== null && scoreTo === null) {
      ScoreSlider.push(scoreFrom);
      ScoreSlider.push(100);
      setScoreToAct('100');
    } else if (scoreTo !== null && scoreFrom === null) {
      ScoreSlider.push(0);
      ScoreSlider.push(scoreTo);
      setScoreFromAct('0');
    } else {
      ScoreSlider.push(scoreFrom);
      ScoreSlider.push(scoreTo);
    }
    setScoreSliderAct(ScoreSlider);

    setErrMsgScoreAct();
    setCheckScoreFromAct(false);
    setCheckScoreToAct(false);
  }

  render(props) {
    const {
      searchErrorFlg,
      showSaveConditionPop,
      showSearchConditionPop,
      addressPopFlg,
      industryPopFlg,
      productsPopFlg,
      tradeInfoPopFlg,
      targetingDispItems,
      dispConditionName,
    } = this.props;

    let dispFlg = false;

    return (
      <Box className="targetCompanySearch">
        <Box className="container1">
          <Box className="section1">
            <Box className="content scrollbar">
              <Box className="buttonfield">
                {dispConditionName && (
                  <div className="balloon-right">
                    <div className="bubble">
                      <span>{dispConditionName.length <= 20 ? dispConditionName : `${dispConditionName.slice(0, 20)}…`}</span>
                    </div>
                    <div className="triangle">
                      <div />
                    </div>
                  </div>
                )}
                <button
                  type="button"
                  className="productslink"
                  onClick={showSearchConditionPop}
                >
                  <Check />
                  保存条件を選択
                </button>
                <button
                  type="button"
                  className="productslink"
                  onClick={showSaveConditionPop}
                  disabled={searchErrorFlg}
                >
                  <BookmarkBorder />
                  指定条件を保存
                </button>
              </Box>
              {/* ----------検索対象---------- */}
              <SerchTargetParts />

              {/* ----------取引情報---------- */}
              <AdditionalInfometionParts />

              {/* --------企業基本情報-------- */}
              <CompanyBasicInfomation
                onBlurSgkn={this.onBlurSgkn}
                onBlurCapital={this.onBlurCapital}
                onBlurEmployees={this.onBlurEmployees}
                onBlurStartYm={this.onBlurStartYm}
                onBlurRepName={this.onBlurRepName}
                onBlurSyrkGkny={this.onBlurSyrkGkny}
              />

              {/* -----評価指標(拡張項目)----- */}
              {targetingDispItems && (targetingDispItems.search_option_list.forEach((label) => {
                if (label.item_name === TARGET_SEARCH_DISP_ITEM.HYOTEN
                  || label.item_name === TARGET_SEARCH_DISP_ITEM.KAKUDUKE) {
                  dispFlg = true;
                }
              }))}
              {dispFlg && (
                <EvaluationIndexParts
                  onBlurScore={this.onBlurScore}
                />
              )}
              {/* ---------決算情報---------- */}
              <SettlementInfomation />

              {/* ----------関連企業---------- */}
              <RelatedCompanyParts />

              {/* ---------事業所情報--------- */}
              <JigyosyoInfomationParts />
            </Box>
            <ScrollTop {...props}>
              <Fab
                aria-label="ページトップ"
                className="topButtonLavel"
              >
                <KeyboardArrowUpIcon />
                <div>TOP</div>
              </Fab>
            </ScrollTop>
          </Box>
        </Box>
        {addressPopFlg && (
          <TargetPopSearchAreaComponent />
        )}
        {industryPopFlg && (
          <TargetPopSearchIndustryComponent />
        )}
        {productsPopFlg && (
          <TargetPopSearchProductsComponent />
        )}
        {tradeInfoPopFlg && (
          <TargetPopSetTradeInfoComponent />
        )}

      </Box>
    );
  }
}

export default connect(
  (state) => ({
    areaList: state.target.areaList,
    tradeInfoSearchItemList: state.target.tradeInfoSearchItemList,
    tradeInfoSearchItem: state.target.tradeInfoSearchItem,
    tradeInfoCondition: state.target.tradeInfoCondition,
    addressCondition: state.target.addressCondition,
    industryCondition: state.target.industryCondition,
    productsCondition: state.target.productsCondition,
    mainIndustryFlg: state.target.mainIndustryFlg,
    prefList: state.target.prefList,
    searchTarget: state.target.searchTarget,
    accountMonth: state.target.accountMonth,
    capitalFrom: state.target.capitalFrom,
    capitalTo: state.target.capitalTo,
    salesFrom: state.target.salesFrom,
    salesTo: state.target.salesTo,
    salesRateFrom: state.target.salesRateFrom,
    salesRateTo: state.target.salesRateTo,
    benefitFrom: state.target.benefitFrom,
    benefitTo: state.target.benefitTo,
    benefitRateFrom: state.target.benefitRateFrom,
    benefitRateTo: state.target.benefitRateTo,
    employeeFrom: state.target.employeeFrom,
    employeeTo: state.target.employeeTo,
    topDuns: state.target.topDuns,
    topTsrCode: state.target.topTsrCode,
    scoreFrom: state.target.scoreFrom,
    scoreTo: state.target.scoreTo,
    officeCountFrom: state.target.officeCountFrom,
    officeCountTo: state.target.officeCountTo,
    repLastName: state.target.repLastName,
    repFirstName: state.target.repFirstName,
    additionalitem: state.target.additionalitem,
    tradesearchflag1: state.target.tradesearchflag1,
    tradesearchflag2: state.target.tradesearchflag2,
    searchCondition: state.target.searchCondition,
    selectArea: state.target.selectArea,
    selectPref: state.target.selectPref,
    dispCapitalFrom: state.target.dispCapitalFrom,
    dispCapitalTo: state.target.dispCapitalTo,
    dispSalesFrom: state.target.dispSalesFrom,
    dispSalesTo: state.target.dispSalesTo,
    dispSalesRateFrom: state.target.dispSalesRateFrom,
    dispSalesRateTo: state.target.dispSalesRateTo,
    dispBenefitFrom: state.target.dispBenefitFrom,
    dispBenefitTo: state.target.dispBenefitTo,
    dispBenefitRateFrom: state.target.dispBenefitRateFrom,
    dispBenefitRateTo: state.target.dispBenefitRateTo,
    dispEmployeesFrom: state.target.dispEmployeesFrom,
    dispEmployeesTo: state.target.dispEmployeesTo,
    dispOfficeCountFrom: state.target.dispOfficeCountFrom,
    dispOfficeCountTo: state.target.dispOfficeCountTo,
    errMsgCapital: state.target.errMsgCapital,
    errMsgSales: state.target.errMsgSales,
    errMsgRate: state.target.errMsgRate,
    errMsgBenefit: state.target.errMsgBenefit,
    errMsgBenefitRate: state.target.errMsgBenefitRate,
    errMsgEmployees: state.target.errMsgEmployees,
    errMsgTopDuns: state.target.errMsgTopDuns,
    errMsgTopTsrCode: state.target.errMsgTopTsrCode,
    errMsgScore: state.target.errMsgScore,
    errMsgOfficeCount: state.target.errMsgOfficeCount,
    errMsgRepName: state.target.errMsgRepName,
    errMsgTradeInfoSearchValue: state.target.errMsgTradeInfoSearchValue,
    checkErrFlg: state.target.checkErrFlg,
    targetListHeaderItem: state.target.targetListHeaderItem,
    userInfo: state.common.userInfo,
    contractLabel: state.common.contractLabel,
    industryDisplayCondition: state.target.industryDisplayCondition,
    productDisplayCondition: state.target.productDisplayCondition,
    selectConditionFlg: state.target.selectConditionFlg,
    addressPopFlg: state.target.addressPopFlg,
    industryPopFlg: state.target.industryPopFlg,
    productsPopFlg: state.target.productsPopFlg,
    marketSegmentList: state.target.marketSegmentList,
    dispJgkbList: state.target.dispJgkbList,
    sgkn: state.target.sgkn,
    startYearFrom: state.target.startYearFrom,
    startMonthFrom: state.target.startMonthFrom,
    startYearTo: state.target.startYearTo,
    startMonthTo: state.target.startMonthTo,
    syrkGkny: state.target.syrkGkny,
    tradeInfoPopFlg: state.target.tradeInfoPopFlg,
    targetingDispItems: state.target.targetingDispItems,
    dispConditionName: state.target.dispConditionName,
  }),
  (dispatch) => ({
    getAreaMasterAct: () => dispatch(getAreaMaster()),
    setAreaAct: (obj) => dispatch(setArea(obj)),
    getAddressMasterAct: (code) => dispatch(getAddressMaster(code)),
    setAddressConditionAct: (obj) => dispatch(setAddressCondition(obj)),
    setIndustryConditionAct: (obj) => dispatch(setIndustryCondition(obj)),
    setProductsConditionAct: (obj) => dispatch(setProductsCondition(obj)),
    setMainIndustryFlgAct: (str) => dispatch(setMainIndustryFlg(str)),
    setAddressPopFlgAct: (bool) => dispatch(setAddressPopFlg(bool)),
    setIndustryPopFlgAct: (bool) => dispatch(setIndustryPopFlg(bool)),
    setProductsPopFlgAct: (bool) => dispatch(setProductsPopFlg(bool)),
    setSearchTargetAct: (str) => dispatch(setSearchTarget(str)),
    setAccountMonthAct: (obj) => dispatch(setAccountMonth(obj)),
    setCapitalFromAct: (str) => dispatch(setCapitalFrom(str)),
    setCapitalToAct: (str) => dispatch(setCapitalTo(str)),
    setSalesFromAct: (str) => dispatch(setSalesFrom(str)),
    setSalesToAct: (str) => dispatch(setSalesTo(str)),
    setSalesRateFromAct: (str) => dispatch(setSalesRateFrom(str)),
    setSalesRateToAct: (str) => dispatch(setSalesRateTo(str)),
    setBenefitFromAct: (str) => dispatch(setBenefitFrom(str)),
    setBenefitToAct: (str) => dispatch(setBenefitTo(str)),
    setBenefitRateFromAct: (str) => dispatch(setBenefitRateFrom(str)),
    setBenefitRateToAct: (str) => dispatch(setBenefitRateTo(str)),
    setEmployeeFromAct: (str) => dispatch(setEmployeeFrom(str)),
    setEmployeeToAct: (str) => dispatch(setEmployeeTo(str)),
    setTopDunsAct: (str) => dispatch(setTopDuns(str)),
    setTopTsrCodeAct: (str) => dispatch(setTopTsrCode(str)),
    setScoreFromAct: (str) => dispatch(setScoreFrom(str)),
    setScoreToAct: (str) => dispatch(setScoreTo(str)),
    setOfficeCountFromAct: (str) => dispatch(setOfficeCountFrom(str)),
    setOfficeCountToAct: (str) => dispatch(setOfficeCountTo(str)),
    setRepLastNameAct: (str) => dispatch(setRepLastName(str)),
    setRepFirstNameAct: (str) => dispatch(setRepFirstName(str)),
    setAdditionalitemAct: (str) => dispatch(setAdditionalitem(str)),
    setTradesearchflag1Act: (bool) => dispatch(setTradesearchflag1(bool)),
    setTradesearchflag2Act: (bool) => dispatch(setTradesearchflag2(bool)),
    setPrefListAct: (obj) => dispatch(setPrefList(obj)),
    setSelectAreaAct: (obj) => dispatch(setSelectArea(obj)),
    setSelectPrefAct: (obj) => dispatch(setSelectPref(obj)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setDispCapitalFromAct: (str) => dispatch(setDispCapitalFrom(str)),
    setDispCapitalToAct: (str) => dispatch(setDispCapitalTo(str)),
    setDispSalesFromAct: (str) => dispatch(setDispSalesFrom(str)),
    setDispSalesToAct: (str) => dispatch(setDispSalesTo(str)),
    setDispSalesRateFromAct: (str) => dispatch(setDispSalesRateFrom(str)),
    setDispSalesRateToAct: (str) => dispatch(setDispSalesRateTo(str)),
    setDispBenefitFromAct: (str) => dispatch(setDispBenefitFrom(str)),
    setDispBenefitToAct: (str) => dispatch(setDispBenefitTo(str)),
    setDispBenefitRateFromAct: (str) => dispatch(setDispBenefitRateFrom(str)),
    setDispBenefitRateToAct: (str) => dispatch(setDispBenefitRateTo(str)),
    setDispEmployeesFromAct: (str) => dispatch(setDispEmployeesFrom(str)),
    setDispEmployeesToAct: (str) => dispatch(setDispEmployeesTo(str)),
    setDispOfficeCountFromAct: (str) => dispatch(setDispOfficeCountFrom(str)),
    setDispOfficeCountToAct: (str) => dispatch(setDispOfficeCountTo(str)),
    setErrMsgCapitalAct: (sr) => dispatch(setErrMsgCapital(sr)),
    setErrMsgSalesAct: (sr) => dispatch(setErrMsgSales(sr)),
    setErrMsgRateAct: (sr) => dispatch(setErrMsgRate(sr)),
    setErrMsgBenefitAct: (sr) => dispatch(setErrMsgBenefit(sr)),
    setErrMsgBenefitRateAct: (sr) => dispatch(setErrMsgBenefitRate(sr)),
    setErrMsgEmployeesAct: (sr) => dispatch(setErrMsgEmployees(sr)),
    setErrMsgTopDunsAct: (sr) => dispatch(setErrMsgTopDuns(sr)),
    setErrMsgTopTsrCodeAct: (sr) => dispatch(setErrMsgTopTsrCode(sr)),
    setErrMsgScoreAct: (sr) => dispatch(setErrMsgScore(sr)),
    setErrMsgOfficeCountAct: (sr) => dispatch(setErrMsgOfficeCount(sr)),
    setErrMsgRepNameAct: (sr) => dispatch(setErrMsgRepName(sr)),
    setErrMsgTradeSearchValueAct: (sr) => dispatch(setErrMsgTradeInfoSearchValue(sr)),
    setCheckCapitalFromAct: (bool) => dispatch(setCheckCapitalFrom(bool)),
    setCheckCapitalToAct: (bool) => dispatch(setCheckCapitalTo(bool)),
    setCheckSalesFromAct: (bool) => dispatch(setCheckSalesFrom(bool)),
    setCheckSalesToAct: (bool) => dispatch(setCheckSalesTo(bool)),
    setCheckRateFromAct: (bool) => dispatch(setCheckRateFrom(bool)),
    setCheckRateToAct: (bool) => dispatch(setCheckRateTo(bool)),
    setCheckBenefitFromAct: (bool) => dispatch(setCheckBenefitFrom(bool)),
    setCheckBenefitToAct: (bool) => dispatch(setCheckBenefitTo(bool)),
    setCheckBenefitRateFromAct: (bool) => dispatch(setCheckBenefitRateFrom(bool)),
    setCheckBenefitRateToAct: (bool) => dispatch(setCheckBenefitRateTo(bool)),
    setCheckEmployeesFromAct: (bool) => dispatch(setCheckEmployeesFrom(bool)),
    setCheckEmployeesToAct: (bool) => dispatch(setCheckEmployeesTo(bool)),
    setCheckTopDunsAct: (bool) => dispatch(setCheckTopDuns(bool)),
    setCheckTopTsrCodeAct: (bool) => dispatch(setCheckTopTsrCode(bool)),
    setCheckScoreFromAct: (bool) => dispatch(setCheckScoreFrom(bool)),
    setCheckScoreToAct: (bool) => dispatch(setCheckScoreTo(bool)),
    setCheckOfficeCountFromAct: (bool) => dispatch(setCheckOfficeCountFrom(bool)),
    setCheckOfficeCountToAct: (bool) => dispatch(setCheckOfficeCountTo(bool)),
    setCheckRepLastNameAct: (bool) => dispatch(setCheckRepLastName(bool)),
    setCheckRepFirstNameAct: (bool) => dispatch(setCheckRepFirstName(bool)),
    setCheckTradeInfoSearchValueAct: (bool) => dispatch(setCheckTradeInfoSearchValue(bool)),
    getTradeInfoMasterAct: (divisionCode) => dispatch(getTradeInfoMaster(divisionCode)),
    setTradeInfoSearchItemListAct: (object) => dispatch(setTradeInfoSearchItemList(object)),
    setTargetListHeaderItemAct: (object) => dispatch(setTargetListHeaderItem(object)),
    setTradeInfoPopFlgAct: (bool) => dispatch(setTradeInfoPopFlg(bool)),
    setTradeInfoSearchItemAct: (str) => dispatch(setTradeInfoSearchItem(str)),
    getContractLabelAct: () => dispatch(getContractLabel()),
    setContractLabelAct: (object) => dispatch(setContractLabel(object)),
    setIndustryAddConditionAct: (obj) => dispatch(setIndustryAddCondition(obj)),
    setProductAddConditionAct: (obj) => dispatch(setProductAddCondition(obj)),
    setSelectConditionFlgAct: (bool) => dispatch(setSelectConditionFlg(bool)),
    getCodeMasterAct: (str) => dispatch(getCodeMaster(str)),
    setMarketSegmentListAct: (obj) => dispatch(setMarketSegmentList(obj)),
    setDispJgkbListAct: (obj) => dispatch(setDispJgkbList(obj)),
    setCheckSgknAct: (bool) => dispatch(setCheckSgkn(bool)),
    setErrMsgSgknAct: (sr) => dispatch(setErrMsgSgkn(sr)),
    setCheckStartYearFromAct: (bool) => dispatch(setCheckStartYearFrom(bool)),
    setCheckStartMonthFromAct: (bool) => dispatch(setCheckStartMonthFrom(bool)),
    setCheckStartYearToAct: (bool) => dispatch(setCheckStartYearTo(bool)),
    setCheckStartMonthToAct: (bool) => dispatch(setCheckStartMonthTo(bool)),
    setErrMsgStartYmAct: (sr) => dispatch(setErrMsgStartYm(sr)),
    setCheckSyrkGknyAct: (bool) => dispatch(setCheckSyrkGkny(bool)),
    setErrMsgSyrkGknyAct: (sr) => dispatch(setErrMsgSyrkGkny(sr)),
    setTargetingDispItemsAct: (obj) => dispatch(setTargetingDispItems(obj)),
    getTargetingDispItemListAct: () => dispatch(getTargetingDispItemList()),
    setScoreSliderAct: (obj) => dispatch(setScoreSlider(obj)),
    getDownloadStatusAct: () => dispatch(getDownloadStatus()),
  }),
)(TargetSearchComponent);
